import { Route, Routes } from 'react-router-dom';

import { DetailNonComplianceTaxpayer } from './views/DetailNonComplianceTaxpayer';
import { NonComplianceStatistics } from './views/NonComplianceStatistics';
import { NonComplianceTaxpayers } from './views/NonComplianceTaxpayers';

export const NonComplianceRouting = () => {
  return (
    <Routes>
      <Route path="" element={<NonComplianceTaxpayers />} />

      <Route path="detail/:id" element={<DetailNonComplianceTaxpayer />} />

      <Route path="statistics" element={<NonComplianceStatistics />} />
    </Routes>
  );
};
